export function onKeyDown(callback) {
	return (event) => {
		if (event.code === "Enter") {
			callback();
		}
	};
}